// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"456":"c16033ce","971":"0979a897"}[chunkId] + ".chunk.css";
};